import header from "./energie-app-auf-tablet.jpg";
import section1 from "./energie-uebersicht.webp";
import section2 from "./energiefluss-eines-hauses.jpg";
import section3 from "./building-with-solar-panels.jpg";
import section4 from "./haus-Photovoltaik-Energieausweis.webp";
import section5 from "./energieapp.jpg";
import section6 from "./energieausweis.webp";

export { header, section1, section2, section3, section4, section5, section6 };
